import React from 'react';
import { connect } from 'react-redux';

import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DetailsItem } from 'apps/auth/components/common/DetailsItem/DetailsItem';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { canShareDetails, copyTextToClipboard, shareDetails } from 'apps/auth/helpers/utils';

const WeixinInfoModal = (props) => {
    const cheque = props.cheque;
    const payoutInfoLink = cheque?.extra?.payout_info_link ?? '';
    const webArticleUrl = cheque?.extra?.webArticleUrl ?? '';

    const copyButtonClick = (textToCopy, messageSnackBar) => {
        return () => {
            const result = copyTextToClipboard(textToCopy);
            if (result) {
                props.toggleSnackBar(true, messageSnackBar);
            }
        };
    };

    const getMessageForSnackBar = (title, copied) => {
        return `${title} ${copied}`;
    };

    return (
        <ModalComponent>
            <HeaderPanel title={props.notifyHeader} subtitle={props.notifySubheader} />
            <Row indent="adaptive-32-48">
                <Panel type="link" target="_blank" isHoverable negativeMargin href={payoutInfoLink}>
                    <Text color="primary">{props.weixinPayoutUrlLabel}</Text>
                </Panel>
            </Row>
            <Row indent="adaptive-32-48">
                <DetailsItem
                    detailsTitle={props.weixinUrlLabel}
                    detailsText={webArticleUrl}
                    detailsButton={props.interacNotifyCopyCode}
                    detailsButtonClick={copyButtonClick(webArticleUrl, getMessageForSnackBar(props.weixinDeliveryLabel, props.copied))}
                />
            </Row>
            {canShareDetails() && (
                <Button
                    type="button"
                    variant="row"
                    size="tight"
                    caption={props.shareDetailsLink}
                    negativeMargin
                    onClick={(e) => {
                        e.preventDefault();
                        shareDetails(`${props.shareTitleDetails}`, `${cheque.shareDetails}`);
                    }}
                />
            )}
        </ModalComponent>
    );
};
const mapStateToProps = (state) => {
    return {
        lang: state.language.lang,
        notifyHeader: state.messages.pageMessages.notifyHeader,
        weixinDeliveryLabel: state.messages.pageMessages.weixinDeliveryLabel,
        notifySubheader: state.messages.pageMessages.weixinNotifySubheader,
        weixinUrlLabel: state.messages.pageMessages.weixinUrlLabel,
        weixinPayoutUrlLabel: state.messages.pageMessages.weixinPayoutUrlLabel,
        interacNotifyCopyCode: state.messages.pageMessages.interacNotifyCopyCode,
        shareDetailsLink: state.messages.pageMessages.shareDetailsLink,
        shareTitleDetails: state.messages.pageMessages.shareTitleDetails,
        copied: state.messages.pageMessages.copied,
    };
};
export default connect(mapStateToProps, { toggleSnackBar })(WeixinInfoModal);
